import React from "react";
import PageContainer from "../../layouts/PageContainer";
import List from "./List";

const PopularityReward = () => {
  return (
    <React.Fragment>
      <PageContainer pageheading="POPULARITY REWARD">
        <List />
      </PageContainer>
    </React.Fragment>
  )
};

export default PopularityReward;